@if (surveyEditorService.surveyEditor$().activeQuestion; as activeQuestion) {
  @if (!activeQuestion.value.inputType || activeQuestion.value.inputType === 'text') {
    <empathy-terms-form
      [allowToggleSettings]="!surveyEditorService.surveyEditor$().form.get('settings').get('monitorTerms').get('monitorProblematicInd').value"
      [monitorProblematicIndCtrl]="activeQuestion.get('monitorTerms').get('monitorProblematicInd') | toFormControl"
      [flagCurseWordsIndCtrl]="activeQuestion.get('monitorTerms').get('flagCurseWordsInd') | toFormControl"
      [flagGibberishIndCtrl]="activeQuestion.get('monitorTerms').get('flagGibberishInd') | toFormControl"
      [blockedTermsCtrl]="activeQuestion.get('monitorTerms').get('blockedTerms') | toFormArray"
      [flaggedTermsCtrl]="activeQuestion.get('monitorTerms').get('flaggedTerms') | toFormArray"
      [customErrorMessageIndCtrl]="activeQuestion.get('monitorTerms').get('customErrorMessageInd') | toFormControl"
      [customErrorMessageCtrl]="activeQuestion.get('monitorTerms').get('customErrorMessage') | toFormControl"
      [questionLevel]="true"
      [gibberishSupported]="activeQuestion.value.type === QuestionType.Essay"
      (csvBlocksImport)="onCsvBlocksImport($event)"
      (csvFlagsImport)="onCsvFlagsImport($event)"
    ></empathy-terms-form>
  }
}
